<template>
  <div style="overflow-x: auto;">
    <b-table
      :items="itemsUserData"
      :fields="fieldsUserData"
      small
      bordered
      fixed
      head-variant="dark"
      class="text-wrap-in-table"
    >
      <template #cell(ex__date)>
        <span>{{ formatDate(exEvaluationDate) }}</span>
      </template>
      <template #cell(created_at)="data">
        <span>{{ formatDate(data.item.created_at) }}</span>
      </template>
      <template #cell(requests_evaluation)="data">
        <span>
          <feather-icon
            v-if="data.item.request_id"
            icon="EyeIcon"
            class="cursor-pointer"
            @click="$emit('showRequestsEvaluation', data.item)"
          />
          <feather-icon
            v-else
            icon="EyeIcon"
            class="cursor-pointer"
            @click="$emit('showRequestsEvaluation', data.item)"
          />
        </span>
      </template>

      <template #cell(evaluator_name)="data">
        <span
          v-if="data.item.evaluator"
          class="hover-text-change"
          @click="$emit('changePersonneleEvaluation', data.item.id, 'evaluator')"
        >{{ data.item.evaluator.name }}</span>
        <span v-else>
          <feather-icon
            icon="PlusCircleIcon"
            class="hover-icon-plus"
            @click="$emit('changePersonneleEvaluation', data.item.id, 'evaluator')"
          />
        </span>
      </template>
      <template #cell(activity)="data">
        <span
          v-if="data.item.activity"
          class="hover-text-change"
          @click="$emit('changePersonneleEvaluation', data.item.id, 'activity')"
        >{{ data.item.activity }}</span>
        <span v-else>
          <feather-icon
            icon="PlusCircleIcon"
            class="hover-icon-plus"
            @click="$emit('changePersonneleEvaluation', data.item.id, 'activity')"
          />
        </span>
      </template>
    </b-table>
  </div>
</template>
<script>

export default {
  props: {
    itemsUserData: {
      type: Array,
      default: () => [],
    },
    exEvaluationDate: {
      type: String,
      default: '',
    },
    fieldsUserData: {
      type: Array,
      default: () => [],
    },
    requestEvaluationId: {
      type: [String, Number],
      default: () => '',
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
    },
  },

}
</script>
